module.exports = __webpack_public_path__ + "static/media/dhvanith_unadkat.10e4b579.jpg";